import { Fragment, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Minus from "../../../../../assets/images/minus-circle.svg";
import {
  instructors as getInstructors,
  deleteInstructors,
} from "../../../../../Store/api/professor/dashboard";
import "./instructors.css";
import { ModalPortal } from "../../../../ModalPortal";
import { CustomModal } from "../../../../../shared/CustomModal";
import { toast } from "react-toastify";

const Instructors = ({ classDetails, setClassDetail, setRefetch }) => {
  const dispatch = useDispatch();

  const [load, setLoad] = useState(false);
  const [current, setCurrent] = useState({});
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [instructors, setInstructors] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  useEffect(() => {
    dispatch(
      getInstructors({
        onSuccess: (res) => {
          setInstructors(res.data.data);
          setLoading(false);
        },
        onError: (err) => {
          setLoading(false);
        },
        id: classDetails._id,
      })
    );
  }, [classDetails, dispatch]);

  const deleteIns = () => {
    setLoad(true);
    dispatch(
      deleteInstructors({
        body: { instructors: [current.email] },
        id: classDetails._id,
        onSuccess: (res) => {
          setClassDetail((old) => ({
            ...old,
            sections: old.sections.map((e) => ({
              ...e,
              instructorEmails: e.instructorEmails.filter(
                (i) => !selectedStudents.includes(i.email)
              ),
            })),
            classData: {
              ...old.classData,
              instructors: old.classData.instructors.filter(
                (i) => !selectedStudents.includes(i)
              ),
            },
          }));
          setInstructors((old) =>
            old.filter((e) => !selectedStudents.includes(e.email))
          );
          setSelectedStudents([]);
          setLoad(false);
          setRefetch(true);
          setShowModal(false);
          toast.success("Instructor removed from class successfully.");
        },
        onError: (err) => {
          setLoad(false);
          toast.error(
            err?.message ||
              err?.data?.message ||
              err?.response?.data?.message ||
              "Error while remove instructor. please try later."
          );
        },
      })
    );
  };

  const onToggle = () => setShowModal((prev) => !prev);
  const handleRemove = (instructor) => {
    setCurrent(instructor);
    onToggle();
  };

  return (
    <>
      <ModalPortal>
        <CustomModal
          loading={load}
          className="gap-3"
          onHide={onToggle}
          onAction={deleteIns}
          showModal={showModal}
          cancelBtnText="Go back"
          actionBtnText="Remove instructor"
          title="remove instructor from class?"
        >
          <p className="mb-0">
            Are you sure you want to remove{" "}
            <b>{`${current.firstName} ${current.lastName} `}</b>
            as an instructor and revoke all access to this classroom? You can
            add them back at anytime.
          </p>
        </CustomModal>
      </ModalPortal>
      <div
        className="tab-pane fade show active"
        id="Contents"
        role="tabpanel"
        aria-labelledby="Contents-tab"
      >
        <div className="Contents_tabs">
          <div className="" id="myContents">
            <div className="grade_table_wrapper students">
              <table className="students_talbe">
                <tbody>
                  <Fragment>
                    <tr
                      className="header_row"
                      style={{ position: "sticky", top: 0, zIndex: 2 }}
                    >
                      <td>instructor name (pronouns)</td>
                      <td>Email address</td>
                      <td>last sign in</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    {loading ? (
                      "Loading..."
                    ) : (
                      <Fragment>
                        {instructors.map((instructor, i) => (
                          <tr className="sub_rows" key={i}>
                            <td>
                              {instructor.firstName} {instructor.lastName}
                            </td>
                            <td>{instructor.email}</td>
                            <td>
                              {instructor.loginSession
                                ? instructor.loginSession.createdAt
                                : "--"}
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <div className="iagree_radio instructors students border-0">
                                <input
                                  type="checkbox"
                                  checked={selectedStudents.includes(
                                    instructor.email
                                  )}
                                  value={1}
                                  className=""
                                />
                                <img
                                  src={Minus}
                                  width={20}
                                  height={20}
                                  alt="delete ico"
                                  className="cursor"
                                  onClick={() => handleRemove(instructor)}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </Fragment>
                    )}
                  </Fragment>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Instructors;
